<template>
    <div>
        <v-card-title>New Student</v-card-title>
        <v-flex xs3>
            <v-select
                hide-details
                :items="classes"
                label="Class"
                ref="chosenClass"
                v-model="student.chosenClass"
                :rules="[
                    value => rules.required(value, student.enrollment.regType)
                ]"
                box
                item-text="`${data.item.grade} - ${data.item.teacher}`"
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.grade }} -
                    {{ data.item.teacher }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title
                            v-html="`${data.item.grade} - ${data.item.teacher}`"
                        >
                        </v-list-tile-title>
                    </v-list-tile-content>
                </template>
            </v-select>
        </v-flex>
    </div>
</template>
<script>
export default {
    props: {
        students: Array,
        account: Object,
        lapidusAccount: Object,
        refresh: Function,
        country: String
    },
    data() {
        return {
            dialogOpen: false
        };
    },
    async created() {
        //await this.loadStudents();
    },
    computed: {},
    methods: {
        openDialog(original) {
            this.original = original;

            this.dialogOpen = true;
        },
        cancel() {
            //this.rollback();

            this.dialogOpen = false;
        },
    }
};
</script>
